import Query from '../../../components/Report';

const query = ({ project_id, url }) => new Query('commerce-detail-url', { project_id, url });

export default query;
